// "Where should we eat?" pool: never the trash; places you both want to try count most, then one of you, then unvisited.
import { isVisited, wantToTryState } from './visits.js';

export function pickerWeight(r) {
    const want = wantToTryState(r);
    let w = 1;
    if (want === 'both') w *= 4;
    else if (want !== 'none') w *= 2;
    if (!isVisited(r)) w *= 2;
    return w;
}

/** { pool, reason } where pool is [{ restaurant, weight }]. Falls back to every live place when nothing is unvisited. */
export function pickerPool(restaurants) {
    const live = (restaurants || []).filter((r) => !r.deletedAt);
    const fresh = live.filter((r) => !isVisited(r) || wantToTryState(r) !== 'none');
    const base = fresh.length ? fresh : live;
    return { pool: base.map((restaurant) => ({ restaurant, weight: pickerWeight(restaurant) })), reason: fresh.length ? 'fresh' : 'all' };
}

export function weightedPick(pool, rng = Math.random) {
    const total = pool.reduce((s, p) => s + p.weight, 0);
    if (!total) return null;
    let x = rng() * total;
    for (const p of pool) { x -= p.weight; if (x < 0) return p.restaurant; }
    return pool[pool.length - 1].restaurant;
}

/** Spin delays in ms: starts fast, slows down like a wheel. */
export function spinDelays(count = 22) {
    return Array.from({ length: count }, (_, i) => Math.round(60 + 12 * i + (i > count - 6 ? 60 * (i - (count - 6)) : 0)));
}

/** Rating → pin color for the map. */
export function ratingColor(rating) {
    if (typeof rating !== 'number') return '#9ca3af';
    if (rating >= 8) return '#22c55e';
    if (rating >= 6) return '#f59e0b';
    return '#ef4444';
}
